var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAnnouncementNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "56px",
    viewBox: "0 0 104 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrations/Notification/Announcement@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Illustrations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrations-/-Institutional-admin",
    transform: "translate(-928, -261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrations/Notification/Announcement",
    transform: "translate(928, 261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#393E4B",
    x: 0,
    y: 0,
    width: 104,
    height: 56,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Accent",
    fill: "#FFFFFF",
    x: 78,
    y: 26,
    width: 20,
    height: 24,
    rx: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnouncementNotification);
export default __webpack_public_path__ + "static/media/icon-announcement-notification.3f7801f8.svg";
export { ForwardRef as ReactComponent };